export enum StorageKeys {
	Software = 'software',
	Music = 'music',
}
